import type { Ref } from "vue";

export function useCountries(current: Ref<{ country: string; state: string }>) {
  const countryOptions = computed(() => Object.entries(countries).map(([code, country]) => ({ label: country.name, value: code })));
  const stateOptions = computed(() => {
    const country = current.value.country || "CA";
    const states = countries[country]?.states || {};
    return Object.entries(states).map(([code, label]) => ({ label, value: code }));
  });
  watch(() => current.value.country, (newCountry) => {
    const newStates = Object.keys(countries[newCountry || ""]?.states || {});
    current.value.state = newStates[0] || "";
  });
  return { countryOptions, stateOptions };
}
